export const workspace = {
  routes: [
    {
      path: "/workspace/library/physical-archive-category",
      component: () => import("../physical-archive/workspace-library-physical-archive-category-view"),
    },
    {
      path: "/workspace/library/physical-archive",
      component: () => import("../physical-archive/workspace-library-physical-archive-view"),
    },
    {
      path: "/workspace/library/electronic-archive",
      component: () => import("../electronic-archive/workspace-library-electronic-archive-view"),
    },
    {
      path: "/workspace/library/electronic-archive-category",
      component: () => import("../electronic-archive/workspace-library-electronic-archive-category-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/physical-archive-category",
      component: () => import("../physical-archive/management-library-physical-archive-category-view"),
    },
    {
      path: "/management/physical-archive",
      component: () => import("../physical-archive/management-library-physical-archive-view"),
    },
    {
      path: "/management/electronic-archive",
      component: () => import("../electronic-archive/management-library-electronic-archive-view"),
    },
    {
      path: "/management/electronic-archive-category",
      component: () => import("../electronic-archive/management-library-electronic-archive-category-view"),
    },
  ],
};

export const gdpr = {
  routes: [
    {
      path: "/physical-archive",
      component: () => import("../physical-archive/organization-physical-archive-view"),
    },
  ],
};
